import { CollectionButtons } from 'components/CollectionButtons'
import MainButton from 'components/MainButton'
import { ProductDisplay } from 'components/ProductDisplay'
import Queue from 'components/Queue'
import Resultbar from 'components/Resultbar'
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { QuizContext } from 'components/MainComponent/MainComponent'
import { itemcollection } from 'data/items'

enum QuizState {
  START,
  ANSWERING,
  FINISHED,
}

const itemsPerSession = 5

export const Quiz = ({
  items,
  isMobile = false,
  returnAnswers,
}: {
  items: Item[]
  isMobile?: boolean

  returnAnswers: (a: Answer[]) => void
}) => {
  const [currentItem, setCurrentItem] = useState(0)
  const [userAnswers, setUserAnswers] = useState<Answer[]>([])
  const [quizState, setQuizState] = useState<QuizState>(QuizState.ANSWERING)

  const handleAnswer = (collectionid: string) => {
    const correct = items[currentItem].correct.includes(collectionid)

    const answer = {
      item: items[currentItem].id,
      answer: collectionid,
      correct,
    }
    setUserAnswers([...userAnswers, answer])

    if (currentItem < items.length - 1) {
      setCurrentItem(currentItem + 1)
    } else {
      returnAnswers([...userAnswers, answer])
      setQuizState(QuizState.FINISHED)
    }
  }
  return (
    <QuizRoot>
      {quizState === QuizState.ANSWERING && items && (
        <>
          <ProductDisplay
            isMobile={isMobile}
            items={items}
            current={currentItem}
            itemId={currentItem + 1}
          />
          <Queue
            current={currentItem}
            answers={userAnswers}
            total={items.length}
          />
          <Question>
            In welcher Sammlung entsorgt man{' '}
            {items[currentItem].unbest_artikel_de}{' '}
            <span>{items[currentItem].name_de}?</span>
          </Question>
          <CollectionButtons
            handleAnswer={handleAnswer}
            item={items[currentItem]}
          />
        </>
      )}
    </QuizRoot>
  )
}

const FinishedDisplay = styled.div`
  width: 100%;
  background-color: var(--beige-bright-2);
  padding: 30px;
  padding-bottom: 30px;
  text-align: center;
  border-radius: 10px;
  span {
    /* width: 100%; */
    display: inline-block;
    margin-bottom: 15px;
  }
`
const QuizRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 60px;
`

const Question = styled.h4`
  font-size: 18px;
  line-height: 1.5em;
  margin-bottom: 30px;

  font-weight: 300;
  width: 100%;
  text-align: center;
  span {
    font-size: 22px;
    display: inline-block;
    width: 100%;
    font-weight: bold;
  }

  @media screen and (max-width: 711px) {
    font-size: 17px;
    margin-bottom: 15px;
    margin-top: 10px;
    span {
      width: unset;
      font-size: 19px;
    }
  }
`
